import type { AllRouteEndpoints } from "../routeTypes";

// Cancelling a run invalidates nothing — the run hook manages its own state.
export const generativeAiAppGroupIdCanvasQaCancelCacheKeys: AllRouteEndpoints[] = [];
